module.exports = __webpack_public_path__ + "img/chose.77f11b46.png";